import * as React from 'react';
import { connect } from 'react-redux';

import {
  changeBranding,
  changeCoverImage,
  changeCompanyInfo,
  changeCropImage,
  changePostcardImageFront,
  changePostcardImageBack,
  changePosterImageBackground,
  createSaveDocument,
  skipStep,
  toggleCrop,
  toggleLogo,
  toggleBranding,
} from '../../actions/actions';
import { productType } from '../../infrastructure/ProductType';
import BrandingsChoosing from '../Steps/BrandingsChoosing';
import CoverImagesChoosing from '../Steps/CoverImagesChoosing';
import CompanyInfoChoosing from '../Steps/CompanyInfoChoosing';
import CropsChoosing from '../Steps/CropsChoosing';
import LogosChoosing from '../Steps/LogosChoosing';
import BrandingsListChoosing from '../Steps/BrandingsListChoosing';
import PostcardImageListFrontChoosing from '../Steps/PostcardImageListFrontChoosing';
import PostcardImageListBackChoosing from '../Steps/PostcardImageListBackChoosing';
import PosterImageBackgroundChoosing from '../Steps/PosterImageBackgroundChoosing'
import AdditionalTextChoosing from '../Steps/AdditionalTextChoosing';
import TitleChoosing from '../Steps/TitleChoosing';
import Stepper from '../Steps/Stepper';
import { IBranding, ICoverImage, ICrop, IDocument, ILogo, IUserData, IValidationItem, IPostcardImage, IPosterImage, ITagline} from './../../infrastructure/interfaces';

export interface IWizardProps {
  document: IDocument;
  taglines: ITagline[];
  productType: string;
  crops: ICrop[];
  brandings: IBranding[];
  postcardImages: IPostcardImage[];
  posterImages: IPosterImage[];
  logos: ILogo[];
  userData: IUserData;
  pagesCount?: number;
  validation?: {
    pagesCountInput?: IValidationItem,
  };
  toggleCrop(crop: ICrop): void;
  toggleLogo(logo: ILogo): void;
  changeCropImage(crop: ICrop, image: string): void;
  skipStep(step: number): void;
  changeBranding(brand: IBranding): void;
  changeCoverImage(image: ICoverImage): void;
  changeCompanyInfo(text: string, field: string): void;
  createSaveDocument(data: IDocument, userID: string): void;
  fetchCrops(): void;
  toggleBranding(brand: IBranding): void
  changePostcardImageFront(image: IPostcardImage): void
  changePostcardImageBack(image: IPostcardImage): void
  changePosterImageBackground(image: IPosterImage): void
}

export interface IWizardState extends React.ComponentState {
  currentStep: number;
  brandings?: IBranding[];
  disclaimers: any[];
  dividers?: any;
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    createSaveDocument: (document: IDocument, userID: string) => {
      dispatch(createSaveDocument(document, userID));
    },
    toggleCrop: (crop: ICrop): void => {
      dispatch(toggleCrop(crop));
    },
    toggleBranding: (brand: IBranding): void => {
      dispatch(toggleBranding(brand));
    },
    postcardImageFront: (image: IPostcardImage): void => {
      dispatch(changePostcardImageFront(image));
    },
    postcardImageBack: (image: IPostcardImage): void => {
      dispatch(changePostcardImageBack(image));
    },
    posterImageBackground: (image: IPosterImage): void => {
      dispatch(changePosterImageBackground(image));
    },
    changeCropImage: (crop: ICrop, image: string): void => {
      dispatch(changeCropImage(crop, image));
    },
    skipStep: (step: number): void => {
      dispatch(skipStep(step));
    },
    changeBranding: (brand: IBranding): void => {
      dispatch(changeBranding(brand));
    },
    changeCoverImage: (image: ICoverImage): void => {
      dispatch(changeCoverImage(image));
    },
    toggleLogo: (logo: ILogo): void => {
      dispatch(toggleLogo(logo));
    },
    changeCompanyInfo: (text: string, field: string) => {
      dispatch(changeCompanyInfo(text, field));
    },
  };
};

const mapStateToProps = (state: any): any => {
  return {
    productType: state.wizard.productType,
    crops: state.wizard.crops,
    logos: state.wizard.logos,
    brandings: state.wizard.brandings,
    document: state.document,
    userData: state.user.data,
    validation: state.wizard.validation,
    postcardImages: state.wizard.postcardImages,
    posterImages: state.wizard.posterImages,
    taglines: state.wizard.taglines,
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class Wizard extends React.Component<IWizardProps, IWizardState>{
  constructor(props: IWizardProps) {
    super(props);
    this.state = {
      currentStep: 0,
      disclaimers: []
    };
  }

  onNextStep = () => this.setState({ currentStep: this.state.currentStep + 1 });
  onPrevStep = () => this.setState({ currentStep: this.state.currentStep - 1 });
  onSkip = () => {
    this.props.skipStep(this.state.currentStep);
    this.onNextStep();
  }
  onSave = () => {
    this.props.createSaveDocument(this.props.document, this.props.userData.id);
  }

  buildSteps = () => {
    switch (this.props.productType) {
      case productType.Brochure:
        {
          return (
            <Stepper
              onNextStep={this.onNextStep}
              onPrevStep={this.onPrevStep}
              currentStep={this.state.currentStep}
              onSkip={this.onSkip}
              onSave={this.onSave}
              documentName={'Quad Fold'}
            >
              <CoverImagesChoosing />
              <TitleChoosing />
              <CropsChoosing />
              <BrandingsChoosing
                  document={this.props.document}
                  brandings={this.props.brandings}
                  changeBranding={this.props.changeBranding}
              />
              <BrandingsListChoosing
                  document={this.props.document}
                  brandings={this.props.brandings}
                  toggleBranding={this.props.toggleBranding}
              />
              <LogosChoosing />
              <CompanyInfoChoosing />
              <AdditionalTextChoosing />
            </Stepper>
          );
        }
      case productType.Catalog:
        {
          return (
            <Stepper
              onNextStep={this.onNextStep}
              onPrevStep={this.onPrevStep}
              currentStep={this.state.currentStep}
              onSkip={this.onSkip}
              onSave={this.onSave}
              documentName={'Catalog'}
              validation={this.props.validation}
            >
              <CoverImagesChoosing />
              <TitleChoosing />
              <CropsChoosing />
              <BrandingsChoosing
                  document={this.props.document}
                  brandings={this.props.brandings}
                  changeBranding={this.props.changeBranding}/>
              <BrandingsListChoosing
                  document={this.props.document}
                  brandings={this.props.brandings}
                  toggleBranding={this.props.toggleBranding}
              />
              <LogosChoosing />
              <CompanyInfoChoosing />
              <AdditionalTextChoosing />
            </Stepper>
          );
        }
      case productType.Bulletin:
        {
          return (
            <Stepper
              onNextStep={this.onNextStep}
              onPrevStep={this.onPrevStep}
              currentStep={this.state.currentStep}
              onSkip={this.onSkip}
              onSave={this.onSave}
              documentName={'Bulletin'}
            >
              <BrandingsListChoosing
                  document={this.props.document}
                  brandings={this.props.brandings}
                  toggleBranding={this.props.toggleBranding}
              />
              <CompanyInfoChoosing />
            </Stepper>
          );
        }
      case productType.Postcard:
        {
          return (
            <Stepper
              onNextStep={this.onNextStep}
              onPrevStep={this.onPrevStep}
              currentStep={this.state.currentStep}
              onSkip={this.onSkip}
              onSave={this.onSave}
              documentName={'Postcard'}
            >
              <CompanyInfoChoosing />
              <PostcardImageListFrontChoosing
                document={this.props.document}
                postcardImagesList={this.props.postcardImages}
                changePostcardImageFront={this.props.changePostcardImageFront}
              />
              <PostcardImageListBackChoosing
                document={this.props.document}
                postcardImagesList={this.props.postcardImages}
                togglePostcardImage={this.props.changePostcardImageBack}
              />
              <AdditionalTextChoosing />
            </Stepper>
          );
        }
        case productType.Poster:
        {
          return (
            <Stepper
              onNextStep={this.onNextStep}
              onPrevStep={this.onPrevStep}
              currentStep={this.state.currentStep}
              onSkip={this.onSkip}
              onSave={this.onSave}
              documentName={'Poster'}
            >
            <PosterImageBackgroundChoosing
              document={this.props.document}
              postcardImagesList={this.props.posterImages}
              changePostcardImageFront={this.props.changePosterImageBackground}
            />
            <AdditionalTextChoosing />
            </Stepper>
          );
        }
      default:
        return (<div></div>);
    }
  }
  
  render() {
    return this.buildSteps();
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard/Wizard.tsx